/** Canonical onboarding_step → route map (resume after login). */
const ONBOARDING_STEP_PATHS = {
  welcome: '/onboarding/welcome',
  profile: '/onboarding/profile',
  cycle_day: '/onboarding/cycle-day',
  method: '/onboarding/method',
  income_sources: '/onboarding/income-sources',
  categories: '/onboarding/categories',
  accounts: '/onboarding/accounts',
  debts: '/onboarding/debts',
  ready: '/onboarding/ready',
};

/** Inverse map — rota actual → `onboarding_step` (usado por «Guardar e sair»). */
export const ONBOARDING_PATH_TO_STEP = Object.fromEntries(
  Object.entries(ONBOARDING_STEP_PATHS).map(([step, path]) => [path, step]),
);

/** Maps legacy onboarding_step values to current routes. */
const ONBOARDING_LEGACY_STEP_PATHS = {
  appearance: '/onboarding/profile',
  method_intro: '/onboarding/method',
  method_preset: '/onboarding/method',
  method_customise: '/onboarding/method',
  income_sources_intro: '/onboarding/income-sources',
  income_sources_select: '/onboarding/income-sources',
  category_intro: '/onboarding/categories',
  category_select: '/onboarding/categories',
  category_review: '/onboarding/categories',
  accounts_intro: '/onboarding/accounts',
  accounts_first: '/onboarding/accounts',
  debts_check: '/onboarding/ready',
  selfie_intro: '/onboarding/ready',
  selfie_first: '/onboarding/ready',
};

export function resolveOnboardingPath(step) {
  return (
    ONBOARDING_STEP_PATHS[step] ||
    ONBOARDING_LEGACY_STEP_PATHS[step] ||
    '/onboarding/welcome'
  );
}
